import WaitUntilQuery from "@/components/WaitUntilQuery.vue";
import useAuthUser from "@/composables/useAuthUser";
import IndexPageInternal from "@/internal/modules/trips/pages/IndexPage.vue";
import { RouteRecordRaw } from "vue-router";

export default {
  path: "/trips/internal",
  children: [
    {
      path: "",
      name: "trips.index.internal",
      component: IndexPageInternal,
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          return next({
            name: "trips.index",
          });
        } else {
          next();
        }
      },
    },
  ],
} as RouteRecordRaw;
